import axiosClient from '../axiosClient';
import { OrderErrorsEndpoints } from '../endpoints/orderErrors';
import {
  IGetOrderErrorsResponse,
  IOrderError,
  IOrderErrorSearchParams,
} from '../../types/api/response/ordererrorsresponse';

export const OrderErrorsService = {
  async getOrderErrors(orderNumber: string): Promise<IOrderError[]> {
    const res = await axiosClient.get<IOrderError[]>(
      OrderErrorsEndpoints.GET_ORDER_ERRORS(orderNumber),
    );
    return res.data;
  },
  async searchOrderErrors(params: IOrderErrorSearchParams): Promise<IGetOrderErrorsResponse> {
    const res = await axiosClient.get<IGetOrderErrorsResponse>(
      OrderErrorsEndpoints.SEARCH_ORDER_ERRORS,
      { params },
    );
    return res.data;
  },
};
